"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");
/**
 * @author VRu
 */


var TagParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(TagParser, _Parser_1$Parser);

  function TagParser(type) {
    var _this;

    _classCallCheck(this, TagParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TagParser).call(this));
    _this.type = type;
    return _this;
  }

  _createClass(TagParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (input !== this.type) {
        return parserSupport_1.badType(input, 'tag');
      }

      return parserSupport_1.succ(input);
    }
  }]);

  return TagParser;
}(Parser_1.Parser);

exports.TagParser = TagParser;